import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const SupplierInvoices = (state: RootState) => state.supportAtHome.supplierInvoices;

export const selectStatuses = (state: RootState) => SupplierInvoices(state).statuses;

export const selectStatusTransitions = createSelector([selectStatuses], (statuses) =>
  statuses.flatMap(({ id, from_statuses = [], to_statuses = [] }) => [
    ...from_statuses.map(({ to_status_id }) => ({
      from: id,
      to: to_status_id,
    })),
    ...to_statuses.map(({ from_status_id }) => ({
      from: from_status_id,
      to: id,
    })),
  ]),
);
export const selectSupplierInvoices = (state: RootState) => SupplierInvoices(state).rows;
export const selectSupplierInvoicesLoading = (state: RootState) => SupplierInvoices(state).loading;
export const selectAllErrors = (state: RootState) => SupplierInvoices(state).error;
export const selectCurrentSupplierInvoice = (state: RootState) => SupplierInvoices(state).row;
export const selectCurrentSupplierInvoiceItems = (state: RootState) => SupplierInvoices(state).row?.items ?? [];
export const selectCurrentSupplierInvoiceEstimate = (state: RootState) => SupplierInvoices(state).estimate;

export const selectCurrentSupplierLoading = (state: RootState) => SupplierInvoices(state).currentSupplierLoading;
export const selectCurrentFile = (state: RootState) => SupplierInvoices(state).row?.file;
export const selectAllFiles = (state: RootState) => SupplierInvoices(state).row?.files || [];
